module.exports = __webpack_public_path__ + "img/护理-1.eaa05433.png";